// routes/_terms.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_terms')

export const handle = { name: 'terms-layout' }

export default dynamic(getClientModule, { ssr: false })
